import { routerApp, baseUrl, enableOnPremise } from '../app.module';
import angular from 'angular';
import { httpRequestGenerator } from './utilities';

routerApp.factory('ClientSettingsService', ['$http', '$log', function($http: angular.IHttpService, $log: angular.ILogService) {
    let cachedClientsById = new Map<string, object>();
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);

    return {
        getClient: (clientId: string) => {
            return requestFunc({
                url: `${baseUrl}clients/${clientId}`,
                method: 'GET'
            });
        },
        setClient: (client: any) => {
            cachedClientsById[client._id] = client;
            return client;
        },
        saveClient: (client: any) => {
            return requestFunc({
                url: `${baseUrl}clients/${client._id}`,
                method: 'POST',
                data: client
            });
        }
    }
}]);
